<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-open-spinners"
  [class.v2-open-spinners--closing]="isClosing"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'OPEN_SPINNER_TITLE' | translate"
>
  <button
    type="button"
    class="v2-rpc-floating-close"
    (click)="onHeaderBack()"
    [class.v2-rpc-floating-in]="headerReveal"
    [attr.aria-label]="'BUTTON_CLOSE' | translate"
  >
    ×
  </button>

  <div
    class="v2-rpc-title-pill v2-os-title-pill"
    [class.v2-rpc-floating-in]="headerReveal"
    [attr.aria-label]="titlePillAriaLabel"
  >
    <span class="v2-os-title-pill__text">{{ 'OPEN_SPINNER_TITLE' | translate }}</span>
    <span *ngIf="spinnerCountBadgeVisible" class="v2-os-title-pill__badge" aria-hidden="true">{{
      spinnerPillCount
    }}</span>
  </div>

  <!-- <div class="v2-open-spinners-rpc-progress" *ngIf="operationInProgress">
    <ion-progress-bar
      type="indeterminate"
      color="primary"
      class="v2-open-spinners-progress"
    ></ion-progress-bar>
  </div> -->

  <!-- v3-display-cards pack-style: full-bleed spinner + bottom tap hint (+ optional actions) -->
  <div
    *ngIf="!dataLoading && (numSpinners > 0 || operationInProgress)"
    class="v2-os-spinner-pack-layer"
    role="region"
    [attr.aria-label]="'OPEN_SPINNER_TITLE' | translate"
  >
    <div
      class="v2-os-spinner-pack-frame"
      [class.v2-os-spinner-pack-frame--open-request]="operationInProgress"
    >
      <div class="v2-os-spinner-stage v2-os-spinner-stage--pack" aria-hidden="false">
        <div
          #SpinnerOpen
          *ngIf="isSpinnerSpining === false"
          class="v2-os-spinner-container v2-os-spinner-container--open"
          role="button"
          tabindex="0"
          (click)="openSpinner()"
          (keydown.enter)="openSpinner()"
          (keydown.space)="$event.preventDefault(); openSpinner()"
        ></div>
        <div #Spinner5 class="v2-os-spinner-container" style="z-index: 5"></div>
        <div #Spinner4 class="v2-os-spinner-container" style="z-index: 4"></div>
        <div #Spinner3 class="v2-os-spinner-container" style="z-index: 3"></div>
        <div #Spinner2 class="v2-os-spinner-container" style="z-index: 2"></div>
        <div #Spinner1 class="v2-os-spinner-container" style="z-index: 1"></div>
      </div>
    </div>

    <div *ngIf="numBindersToOpen > 0 || pcents > 0" class="v2-os-spinner-pack-actions">
      <div
        class="v2-os-secondary-actions v2-os-spinner-pack-actions__inner"
        role="region"
        aria-labelledby="v2-os-pack-secondary-heading"
      >
        <!-- <h2 class="v2-os-eyebrow" id="v2-os-pack-secondary-heading">{{ 'OPEN_BINDERS_MORE_OPTIONS' | translate }}</h2> -->
        <app-btn
          *ngIf="pcents > 0"
          class="v2-rpc-action-btn"
          [text]="'V2_OVERLAY_BUY_MORE' | translate"
          icon="chevron-forward-outline"
          [type]="operationInProgress ? 'disabled' : 'neutral'"
          (clicked)="gotoGet()"
        ></app-btn>
        <app-btn
          *ngIf="numBindersToOpen > 0"
          class="v2-rpc-action-btn"
          [text]="'V2_OVERLAY_OPEN_BINDERS' | translate"
          icon="chevron-forward-outline"
          [type]="operationInProgress ? 'disabled' : 'neutral'"
          (clicked)="gotoOpenBinders()"
        ></app-btn>
      </div>
    </div>

    <p
      class="v2-os-tap-hint v2-os-pack-tap-hint"
      [class.v2-os-tap-hint--stacked]="numBindersToOpen > 0 || pcents > 0"
      [class.v2-os-tap-hint--hide]="!spinnerTapHintVisible"
      aria-hidden="true"
    >
      {{ 'OPEN_SPINNER_TEXT_1' | translate }}
    </p>
  </div>

  <div class="v2-rpc-body" *ngIf="dataLoading || numSpinners < 1">
    <div class="v2-rpc-scroll-outer v2-request-phys-col-scroll">
      <div
        class="manage-wrapper v2-req-phys-wrap v2-os-wrap"
        [class.opened]="contentReveal && !dataLoading"
        [class.loaded]="contentReveal && !dataLoading"
      >
        <main class="v2-rpc-scroll">
          <div *ngIf="dataLoading" class="v2-os-skeleton-panel" aria-busy="true">
            <div class="v2-os-skeleton-top-row">
              <div class="v2-os-skeleton-hero"></div>
              <div class="v2-os-skeleton-stats">
                <div class="v2-os-skeleton-line"></div>
                <div class="v2-os-skeleton-line v2-os-skeleton-line--short"></div>
                <div class="v2-os-skeleton-line v2-os-skeleton-line--medium"></div>
              </div>
            </div>
            <div class="v2-os-skeleton-actions" aria-hidden="true">
              <div class="v2-os-skeleton-btn-bar"></div>
              <div class="v2-os-skeleton-btn-bar"></div>
              <div class="v2-os-skeleton-btn-bar v2-os-skeleton-btn-bar--short"></div>
            </div>
            <p class="v2-os-loading-caption">{{ 'LOADING' | translate }}</p>
          </div>

          <ng-container *ngIf="!dataLoading">
            <!-- Same pattern as v2-open-binders empty RPC: centered collection art only -->
            <div class="v2-rpc-item">
              <div class="v2-os-empty-rpc-icon">
                <div class="v2-os-image-frame v2-os-empty-rpc-icon__frame" *ngIf="collectionIconPath">
                  <ion-img
                    [ngClass]="{ fade: hasImgLoaded }"
                    class="v2-os-hero-img"
                    (ionImgDidLoad)="hasLoaded()"
                    [src]="collectionIconPath"
                  ></ion-img>
                  <div
                    class="v2-os-img-shimmer"
                    *ngIf="!hasImgLoaded"
                    aria-hidden="true"
                  ></div>
                </div>
                <div
                  *ngIf="!collectionIconPath"
                  class="v2-os-image-placeholder v2-os-empty-rpc-icon__frame"
                  aria-hidden="true"
                ></div>
              </div>
            </div>

            <ng-container *ngIf="numSpinners === 0">
              <div class="v2-rpc-item">
                <div class="v2-rpc-lbl">
                  <h2 class="ion-text-wrap ion-text-center">{{ 'OPEN_SPINNER_HEADER' | translate }}</h2>
                  <br />
                  <p class="ion-text-wrap ion-text-center">{{ 'OPEN_SPINNER_TEXT_2' | translate }}</p>
                </div>
              </div>

              <div class="v2-rpc-item" *ngIf="numBindersToOpen > 0 || pcents > 0">
                <div
                  class="v2-os-secondary-actions v2-os-empty-rpc__secondary"
                  role="region"
                  aria-labelledby="v2-os-secondary-heading"
                >
                  <h2 class="v2-os-eyebrow" id="v2-os-secondary-heading">{{ 'OPEN_BINDERS_MORE_OPTIONS' | translate }}</h2>
                  <app-btn
                    *ngIf="pcents > 0"
                    class="v2-rpc-action-btn"
                    [text]="'V2_OVERLAY_BUY_MORE' | translate"
                    icon="chevron-forward-outline"
                    [type]="operationInProgress ? 'disabled' : 'neutral'"
                    (clicked)="gotoGet()"
                  ></app-btn>
                  <app-btn
                    *ngIf="numBindersToOpen > 0"
                    class="v2-rpc-action-btn"
                    [text]="'V2_OVERLAY_OPEN_BINDERS' | translate"
                    icon="chevron-forward-outline"
                    [type]="operationInProgress ? 'disabled' : 'neutral'"
                    (clicked)="gotoOpenBinders()"
                  ></app-btn>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </main>
      </div>
    </div>
  </div>
</div>
